import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { SplashScreen } from '../models/splashScreen';

interface GetSplashScreensResponse {
	mobile_app_intro_sliders: SplashScreen[];
}

export const onGetScreens = () => {
	return axios.get<JsonResponse<GetSplashScreensResponse>>(`${environment.BASE_API_ENDPOINT}/admin/mobile-app-intro-sliders`);
};

export const onGetScreen = (screenId: string) => {
	return axios.get<JsonResponse<SplashScreen>>(`${environment.BASE_API_ENDPOINT}/admin/mobile-app-intro-sliders/${screenId}`);
};

export const onCreateScreen = (screenData: FormData) => {
	return axios.post<JsonResponse<GetSplashScreensResponse>>(`${environment.BASE_API_ENDPOINT}/admin/mobile-app-intro-sliders`, screenData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onUpdateScreen = (screenId: number, screenData: FormData) => {
	return axios.post<JsonResponse<SplashScreen>>(`${environment.BASE_API_ENDPOINT}/admin/mobile-app-intro-sliders/${screenId}`, screenData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onDeleteScreen = (screenId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/mobile-app-intro-sliders/${screenId}`);
};
